import React, { useEffect, useState } from 'react';
import './Projects.css';
import { FaReact, FaNodeJs, FaAws, FaDatabase, FaDocker, FaAngular, FaGithub, FaGitlab, FaGoogle, FaJava, FaJenkins, FaMicrosoft, FaPython, FaVuejs } from 'react-icons/fa';
import { SiRubyonrails, SiPostgresql, SiMongodb, SiMaterialdesign, SiHtml5, SiCss3, SiJquery, SiAwsamplify, SiFirebase, SiTerraform, SiArgo } from 'react-icons/si';
import { Project } from '../types';
import { getProjects } from '../data/localDataService';
import { GrDeploy, GrKubernetes } from "react-icons/gr";

const techIcons: { [key: string]: JSX.Element } = {
  "ReactJS": <FaReact aria-hidden="true" />,
  "NodeJS": <FaNodeJs aria-hidden="true" />,
  "AWS": <FaAws aria-hidden="true" />,
  "PostgreSQL": <SiPostgresql aria-hidden="true" />,
  "MongoDB": <SiMongodb aria-hidden="true" />,
  "Ruby On Rails": <SiRubyonrails aria-hidden="true" />,
  "Material UI": <SiMaterialdesign aria-hidden="true" />,
  "HTML5": <SiHtml5 aria-hidden="true" />,
  "CSS3": <SiCss3 aria-hidden="true" />,
  "jQuery": <SiJquery aria-hidden="true" />,
  "AWS-ECS": <SiAwsamplify aria-hidden="true" />,
  'Cognito': <FaAws aria-hidden="true" />,
  'Lambda': <FaAws aria-hidden="true" />,
  'ECS': <FaAws aria-hidden="true" />,
  'Jenkins': <FaJenkins aria-hidden="true" />,
  'Docker': <FaDocker aria-hidden="true" />,
  'GraphQL': <FaDatabase aria-hidden="true" />,
  'CI/CD': <FaGitlab aria-hidden="true" />,
  'GitLab': <FaGitlab aria-hidden="true" />,
  'GitHub': <FaGithub aria-hidden="true" />,
  'Heroku': <GrDeploy aria-hidden="true" />,
  'Netlify': <GrDeploy aria-hidden="true" />,
  'Firebase': <SiFirebase aria-hidden="true" />,
  'GCP': <FaGoogle aria-hidden="true" />,
  'Azure': <FaMicrosoft aria-hidden="true" />,
  'Kubernetes': <GrKubernetes aria-hidden="true" />,
  'Terraform': <SiTerraform aria-hidden="true" />,
  'ArgoCD': <SiArgo aria-hidden="true" />,
  'Java': <FaJava aria-hidden="true" />,
  'Spring Boot': <FaJava aria-hidden="true" />,
  'Python': <FaPython aria-hidden="true" />,
  'Node.js': <FaNodeJs aria-hidden="true" />,
  'Express.js': <FaNodeJs aria-hidden="true" />,
  'Hibernate': <FaJava aria-hidden="true" />,
  'Maven': <FaJava aria-hidden="true" />,
  'Gradle': <FaJava aria-hidden="true" />,
  'JUnit': <FaJava aria-hidden="true" />,
  'Mockito': <FaJava aria-hidden="true" />,
  'Jest': <FaReact aria-hidden="true" />,
  'React': <FaReact aria-hidden="true" />,
  'Angular': <FaAngular aria-hidden="true" />,
  'Vue.js': <FaVuejs aria-hidden="true" />,
  'Next.js': <FaReact aria-hidden="true" />,
  'Gatsby': <FaReact aria-hidden="true" />,
  'Nuxt.js': <FaVuejs aria-hidden="true" />,
  'Redux': <FaReact aria-hidden="true" />,
  'Vuex': <FaVuejs aria-hidden="true" />,
  'Tailwind CSS': <SiCss3 aria-hidden="true" />,
  'Bootstrap': <SiCss3 aria-hidden="true" />,
  'JQuery': <SiJquery aria-hidden="true" />,
};


const Projects: React.FC = () => {
  const [projects, setProjects] = useState<Project[]>([])

  useEffect(() => {
    async function fetchProjects() {
      const data = await getProjects();
      setProjects(data);
    }

    fetchProjects()
  }, [])

  if (projects.length === 0) return (
    <div role="status" aria-live="polite" aria-busy="true">
      Loading projects...
    </div>
  );

  return (
    <article className="projects-container">
      <header className="projects-header">
        <h1 className="projects-title">Projects &amp; Portfolio</h1>
        <p className="projects-subtitle">
          AI infrastructure, blockchain, DeFi, and open-source projects by Shivom Sharma
        </p>
      </header>

      <section className="projects-grid" aria-label="Project gallery">
        {projects.map((project, index) => (
          <article
            key={index}
            className="project-card"
            style={{ '--delay': `${Math.min(index * 50, 400)}ms` } as React.CSSProperties}
            itemScope
            itemType="https://schema.org/CreativeWork"
          >
            <div className="project-media">
              <img
                src={project.image.url}
                alt={`${project.title} project screenshot`}
                className="project-image"
                loading="lazy"
                width="400"
                height="250"
                itemProp="image"
              />
            </div>
            <div className="project-details">
              <h2 itemProp="name">{project.title}</h2>
              <p itemProp="description">{project.description}</p>
              <ul className="tech-used" aria-label={`Technologies used: ${project.techUsed}`}>
                {project.techUsed.split(', ').filter(Boolean).map((tech, i) => (
                  <li key={`${tech}-${i}`} className="tech-badge" itemProp="keywords">
                    {techIcons[tech] || <span aria-hidden="true">🔧</span>} {tech}
                  </li>
                ))}
              </ul>
            </div>
          </article>
        ))}
      </section>
    </article>
  );
};

export default Projects;
